import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesHypmono = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
https://www.kidney-international.org/article/S0085-2538(22)00911-5/fulltext  <br /> 

</div>
)
}